export const DEFAULT_PIN_COLOR = "#000000";
export const ACTIVE_PIN_COLOR = "#FF6600";
export const DEFAULT_SCHEDULE = " - ";
export const DEFAULT_TOTAL_PRICE = "$0.00";
export const DEFAULT_CARS_COUNT = 20;
export const FIXED_ZOOM = 13;
export const DEFAULT_MIAMI_CENTER = { lat: 25.7617, lng: -80.1918 };
export const CUSTOM_MAP_STYLE = [
    { featureType: "administrative", elementType: "all", stylers: [{ saturation: "-100" }] },
    { featureType: "administrative.province", elementType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "landscape", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: "on" }] },
    { featureType: "poi", elementType: "all", stylers: [{ saturation: -100 }, { lightness: "50" }, { visibility: "off" }] },
    { featureType: "road", elementType: "all", stylers: [{ lightness: "50" }, { saturation: "-100" }] },
    { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
    { featureType: "road.arterial", elementType: "all", stylers: [{ lightness: "30" }] },
    { featureType: "road.local", elementType: "all", stylers: [{ lightness: "0" }] },
    { featureType: "transit", elementType: "all", stylers: [{ saturation: -10 }, { visibility: "simplified" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ hue: "#ffff00" }, { lightness: 50 }, { saturation: -97 }] },
    { featureType: "water", elementType: "labels", stylers: [{ lightness: -25 }, { saturation: -100 }] },
];
